import { Routes } from '@angular/router';
import { SidenavComponent } from './containers/sidenav/navbar/sidenav.component';
import { PageNotFoundComponent } from './containers/page-not-found/page-not-found.component';
import { AuthGuardService } from './_Common/_Services/auth-guard.service';
import { RoleRouteGuardService } from './_Common/_Guards/role-route.guard';

export const routes: Routes = [
  // for login path
  {
    path: 'signin',
    loadChildren: () =>
      import('./containers/login/login.module').then((m) => m.LoginModule),
  },
  {
    path: 'resetPassword',
    loadChildren: () =>
      import('./containers/login/reset-password/reset-password.module').then(
        (m) => m.ResetPasswordModule
      ),
  },
  {
    path: 'demo',
    loadChildren: () =>
      import('./containers/demo/demo.module').then((m) => m.DemoModule),
  },
  {
    path: '',
    component: SidenavComponent,
    canActivate: [AuthGuardService],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'management-dashboard',
      },
      {
        path: 'agent-dashboard',
        loadChildren: () =>
          import('./containers/proxy-dashboard/proxy-dashboard.module').then(
            (m) => m.ProxyDashboardModule
          ),
      },
      {
        path: 'operation-dashboard',
        loadChildren: () =>
          import('./containers/v2.dashboard/v2.dashboard.module').then(
            (m) => m.V2DashboardModule
          ),
      },
      {
        path: 'management-dashboard',
        loadChildren: () =>
          import('./containers/v3.dashboard/v3.dashboard.module').then(
            (m) => m.V3DashboardModule
          ),
      },
      {
        path: 'dashboard-v3',
        redirectTo: 'management-dashboard',
        pathMatch: 'full',
      },
      {
        path: 'accounts',
        loadChildren: () =>
          import('./containers/proxy-accounts/proxy-accounts.module').then(
            (m) => m.AccountsProxyModule
          ),
      },
      {
        path: 'allocations',
        canActivate: [RoleRouteGuardService],
        data: { redirectTo: 'dashboard-v3' },
        loadChildren: () =>
          import(
            './containers/proxy-allocations/proxy-allocations.module'
          ).then((m) => m.ProxyAllocationsModule),
      },
      {
        path: 'payments',
        loadChildren: () =>
          import('./containers/proxy-payments/proxy-payments.module').then(
            (m) => m.PaymentsProxyModule
          ),
      },
      {
        path: 'bureauReports',
        loadChildren: () =>
          import(
            './containers/proxy-bureau-reports/proxy-bureau-reports.module'
          ).then((m) => m.ProxyBureauReportsModule),
      },
      {
        path: 'importData',
        loadChildren: () =>
          import('./containers/dataImporter/data-importer.module').then(
            (m) => m.DataImporterModule
          ),
      },
      {
        path: 'excelImport',
        loadChildren: () =>
          import('./containers/excelImporter_v3/excelImport.module').then(
            (m) => m.ExcelImportModule
          ),
      },
      {
        path: 'oldRuleEngine',
        loadChildren: () =>
          import('./containers/rule-engine/rule-engine.module').then(
            (m) => m.RuleEngineModule
          ),
      },
      {
        path: 'ruleEngine',
        loadChildren: () =>
          import('./containers/ruleEngine-v2/ruleEngine.module').then(
            (m) => m.RuleEngineV2Module
          ),
      },
      {
        path: 'viewDatabase',
        loadChildren: () =>
          import('./containers/showDatabase/show-database.module').then(
            (m) => m.ShowDatabaseModule
          ),
      },
      {
        path: 'createTemplates',
        loadChildren: () =>
          import('./containers/create-templates/create-templates.module').then(
            (m) => m.CreateTemplatesModule
          ),
      },
      {
        path: 'viewAgencies',
        loadChildren: () =>
          import('./containers/agencies-view/agencies-view.module').then(
            (m) => m.AgenciesViewModule
          ),
      },
      {
        path: 'viewAgents',
        loadChildren: () =>
          import('./containers/agents-view/agents-view.module').then(
            (m) => m.AgentsViewModule
          ),
      },
      {
        path: 'offers',
        loadChildren: () =>
          import('../app/containers/offers/offers.module').then(
            (m) => m.OffersModule
          ),
      },
      {
        path: 'organizations',
        canActivate: [RoleRouteGuardService],
        data: { redirectTo: 'dashboard-v3' },
        loadChildren: () =>
          import('./containers/oganizations/oganizations.module').then(
            (m) => m.OganizationsModule
          ),
      },
      {
        path: 'subscriptions',
        loadChildren: () =>
          import('./containers/subscription/subscription.module').then(
            (m) => m.SubscriptionModule
          ),
      },
      /*
       * single entity views - Agency | Agent | Case | Timeline etc...
       */
      {
        path: 'timeline/:dueId',
        loadChildren: () =>
          import('./containers/timeline4/timeline4.module').then(
            (m) => m.Timeline4Module
          ),
      },
      {
        path: 'agency/:agencyId',
        loadChildren: () =>
          import('./containers/agency/agency.module').then(
            (m) => m.AgencyModule
          ),
      },
      {
        path: 'agent/:agentId',
        canActivate: [RoleRouteGuardService],
        data: { redirectTo: 'dashboard-v3' },
        loadChildren: () =>
          import('./containers/agent/agent.module').then((m) => m.AgentModule),
      },
      {
        path: 'm-timeline/:dueId',
        loadChildren: () =>
          import(
            './components/mobile-components/mobile-timeline/m-timeline.module'
          ).then((m) => m.MobileTimelineModule),
      },
      {
        path: 'm-route-plan',
        loadChildren: () =>
          import(
            './components/mobile-components/mobile-route-plan/mobile-route-plan.module'
          ).then((m) => m.MobileRouteModule),
      },
      {
        path: 'page-not-found',
        pathMatch: 'full',
        component: PageNotFoundComponent,
      },
      {
        path: 'gmailRedirect',
        loadChildren: () =>
          import('./containers/gmail-redirect/gmail-redirect.module').then(
            (m) => m.GmailRedirectModule
          ),
      },
      // for error
      { path: '**', redirectTo: 'page-not-found' },
    ],
  },
  // default and error routes
  {
    path: '',
    redirectTo: 'signin',
    pathMatch: 'full',
  },
  { path: '**', redirectTo: 'signin' },
];
